import { render, staticRenderFns } from "./Parallax-Glider-Two.vue?vue&type=template&id=1361a670&scoped=true"
import script from "./Parallax-Glider-Two.vue?vue&type=script&lang=js"
export * from "./Parallax-Glider-Two.vue?vue&type=script&lang=js"
import style0 from "./Parallax-Glider-Two.vue?vue&type=style&index=0&id=1361a670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361a670",
  null
  
)

export default component.exports